module.exports = __webpack_public_path__ + "media/src/images/abouts/items/online/ehon_1_1-575aaf0964d3f84843a5991f973d0b85.jpg";